import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingWizard from '../components/onboarding/OnboardingWizard';

const AdminOnboarding: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto py-6">
      <OnboardingWizard onComplete={() => navigate('/dashboard')} />
    </div>
  );
};

export default AdminOnboarding;
